import { LinearProgress } from '@material-ui/core';
import Typography from '@mui/material/Typography';
import React from 'react';

/**
 * Пропсы компонента
 */
type CalculationsMenuStatusProps = {
  isLoading: boolean;
  emptyText: string;
};

/**
 * Загрузка или пустой список в кратком меню
 */
export const CalculationsMenuStatus = ({ isLoading, emptyText }: CalculationsMenuStatusProps) => (
  <div className="calculations-menu__status">
    {isLoading ? <LinearProgress /> : <Typography>{emptyText}</Typography>}
  </div>
);
